import React, { useState, useEffect } from "react";
import axios from "axios";

const Products = () => {
  const [product, setProduct] = useState([]);

  useEffect(() => {
    getAllProducts();
  }, []);

  const getAllProducts = async (e) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}product`
      );
      // console.log(response);
      setProduct(response.data.products);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section id="product" className="pt-24  pb-2 md:pt-16 md:mt-16">
      <div className="mx-auto container">
        <div
          className="w-full text-slate-800 md:mx-10 px-6 md:px-20"
          data-aos="fade-left"
          data-aos-duration="800"
        >
          <h3 className="font-poppins text-3xl md:text-3xl font-medium  border-l-4 border-secondary pl-4">
            Produk <span className="text-secondary"> Kami</span>
          </h3>
          <p className="font-poppins font-light text-slate-500 text-sm mt-4">
            Berbagai macam produk kami sediakan untuk anda
          </p>
        </div>
        <div
          className="mx-4 mt-8 md:px-8 flex flex-wrap gap-4  justify-center cursor-pointer"
          data-aos="flip-right"
          data-aos-duration="800"
        >
          {product.map((prd, i) => (
            <div
              key={i}
              className="w-[47%] md:w-[18%] md:mx-4 hover:-translate-y-2 transition duration-200"
            >
              <div className="h-[168px] md:h-[225px] shadow-sm rounded-2xl bg-slate-800 overflow-hidden hover:shadow-xl transition duration-200">
                <img src={prd.url} className="w-full h-full" />
              </div>
              <p className="w-full text-center mt-4 text-slate-800 font-poppins font-semibold">
                {prd.name}
              </p>
            </div>
          ))}
        </div>
        <div
          className="mt-14 mb-4 flex justify-center w-full"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <a
            href="https://store.anjaskonveksi.biz.id/"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-3 px-8 py-3.5 bg-secondary text-white rounded-full font-poppins font-medium text-lg shadow-[0_10px_20px_rgba(123,63,0,0.3)] hover:shadow-[0_15px_30px_rgba(123,63,0,0.4)] hover:bg-[#683500] hover:-translate-y-1.5 transition-all duration-300 active:translate-y-0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-6 h-6 group-hover:scale-110 group-hover:rotate-[-5deg] transition-transform duration-300"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
              />
            </svg>
            Order Sekarang
          </a>
        </div>
      </div>
    </section>
  );
};

export default Products;
